import React, { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

/**
 * Przełącznik motywu jasny/ciemny. Stan trzymany w `localStorage.theme`
 * ('light' | 'dark') i odzwierciedlany klasą `dark` na <html>. Inicjalna klasa
 * jest ustawiana wcześnie w index.html, więc tu tylko czytamy/zmieniamy stan.
 */
function isDark(): boolean {
  return document.documentElement.classList.contains('dark');
}

const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
  const [dark, setDark] = useState<boolean>(() => isDark());

  // Synchronizacja, gdyby klasę zmieniono gdzie indziej.
  useEffect(() => {
    setDark(isDark());
  }, []);

  const toggle = () => {
    const next = !dark;
    document.documentElement.classList.toggle('dark', next);
    try {
      localStorage.setItem('theme', next ? 'dark' : 'light');
    } catch {
      /* localStorage niedostępny — ignorujemy */
    }
    setDark(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? 'Tryb jasny / Light mode' : 'Tryb ciemny / Dark mode'}
      title={dark ? 'Tryb jasny / Light mode' : 'Tryb ciemny / Dark mode'}
      className={
        className ??
        'flex-shrink-0 p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors dark:text-gray-300 dark:hover:bg-gray-800'
      }
    >
      {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
};

export default ThemeToggle;
